<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-sm-12 ">
        <div
            v-if="canAdd"
            class="data-list-item add mb-2"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">
                    {{ $t('common.add_new') }}
                </span>
                <font-awesome-icon
                    icon="user"
                    class="card-body-icon"
                />
            </div>
        </div>
        <Transition name="fade">
            <div
                v-if="resultList.length > 0"
                class="col-sm-12 list-content result-table"
            >
                <vue3-datatable
                    ref="resultTable"
                    :rows="resultList"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="52em"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitEdit"
                />
            </div>
        </Transition>
    </div>
</template>

<script>

import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ApiKeysList',
    components: {Vue3Datatable},
    mixins: [],
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
        canAdd: Boolean
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            fields: [
                {field: 'id', title: this.$t('api_keys.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'company', title: this.$t('api_keys.company'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('api_keys.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'purpose', title: this.$t('api_keys.purpose'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('api_keys.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'service_provider', title: this.$t('api_keys.service_provider'), sort: true, headerClass: 'routa-table-header'},
                {field: 'api_key', title: this.$t('api_keys.key'), sort: true, headerClass: 'routa-table-header'},
            ],
            resultList: [],
            spreaderServiceProviders: [
                {text: 'Arctic Machine', value: 1},
                {text: 'Fleetlogis', value: 3},
                {text: 'Rasco', value: 2}
            ],
            integrationServiceProviders: [
                {text: 'Buildie', value: 1},
            ],
            loading: false
        }
    },
    watch: {
        results() {
            this.resultList = []
            let temp = []
            this.results.forEach(item => {
                let newItem = { ...item };
                newItem.company = item.company ? item.company.name : ''
                newItem.status = item.status === 1 ? this.$t('api_keys.active') : this.$t('api_keys.inactive')
                newItem.type = item.type ? this.getTypeText(item.type) : ''
                newItem.service_provider = this.getServiceProvider(item)
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        }
    },
    mounted() {
        this.resultList = this.results
    },
    methods: {
        getServiceProvider(item) {
            if (item.service_provider) {
                const val = item.type
                if (val === 5) {
                    const provider = this.spreaderServiceProviders.find(data => data.value === item.service_provider)
                    return provider ? provider.text : ''
                } else if(val === 7) {
                    const provider = this.integrationServiceProviders.find(data => data.value === item.service_provider)
                    return provider ? provider.text : ''
                }
            }
            return ''
        },

        emitEdit: function (result) {
            let item = this.results.find(item => result.id === item.id)
            if (item) {
                this.$emit('edit', item)
            }
        },
        getTypeText(value) {
            switch (value) {
            case 1: return this.$t('api_keys.type_contract')
            case 2: return this.$t('api_keys.type_delivery')
            case 3: return this.$t('api_keys.type_gis')
            case 4: return this.$t('api_keys.type_ticket')
            case 5: return this.$t('api_keys.type_spreader')
            case 6: return "Harja"
            case 7: return this.$t('api_keys.type_integration')
            case 8: return "Louhi"
            case 9: return "Tiera"
            case 10: return "Louhi-Infra"
            case 11: return this.$t('api_keys.type_sensors')
            case 12: return this.$t('api_keys.pavement_report')
            }
            return this.$t('common.unknown')
        }
    }
}
</script>
